module.exports = __webpack_public_path__ + "img/work-slide-03.f6ecf2d7.jpg";